module.exports = __webpack_public_path__ + "static/media/accident_wide_scene.0504560e.svg";